import React from 'react';
import { connect } from 'react-redux'
import { NAME as WORD_PAIRS_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as letterJumbleContainerActions } from '../actions'
import LetterJumbleImg from "../../../assets/letter-jumble.svg"; //TO DO
import { CSSTransition } from "react-transition-group";
import Timer from "../../Timer/container/Timer"
import ProgressInfo from "../../../components/ProgressInfo";
import GameOver from "../../../components/GameOver";
import { strings } from "../../../constants/strings";
import Grid from "./Grid"
import CountDown from "../../../components/CountDown";
import { LETTER_PAIRS } from "../../../constants/letter-pairs";
import { getAlphabetForLetterJumble } from '../../../helpers/alphabetProvider'
import { analyticsActions } from "constants/analytics-actions-id";

import StartOverlay from "components/StartOverlay";

const lang = document.documentElement.lang.slice(0, 2); //TO DO
const INFINITY = 2000000000

function generateMatrix(state) {
  let newLeftToFind = 0
  let alphabet
  let letterPair = LETTER_PAIRS[lang][Math.floor(Math.random() * LETTER_PAIRS[lang].length)];
  let newList = []
  switch (state.currentRound) {
    case 0:
    case 1:
      alphabet = getAlphabetForLetterJumble('lower', lang)
      letterPair = letterPair.map(function (value) {
        return value.toLowerCase();
      });
      break;
    case 2:
    case 3:
      alphabet = getAlphabetForLetterJumble('upper', lang)
      break;
    default:
      alphabet = getAlphabetForLetterJumble('mix', lang)
      break;
  }
  let newMatrix = []
  for (let i = 0; i < state.GRIG_HEIGHT; i++) {
    let newRow = []
    for (let j = 0; j < state.GRID_WIDTH; j++) {
      let letter
      do {
        letter = alphabet[Math.floor(Math.random() * alphabet.length)];
      } while (letterPair.includes(letter))
      newRow.push({ value: letter })
    }
    newMatrix.push(newRow)
  }        
  for (let i = 0; i <9; i++) {
    let randi
    let randj
    let condition
    do {
      randi = Math.floor(Math.random() * state.GRIG_HEIGHT);            
      randj = Math.floor(Math.random() * state.GRID_WIDTH);            
      condition = letterPair.includes(newMatrix[randi][randj].value)
      if (!condition) {
        newList.push({
          rowIndex: randi,
          columnIndex: randj,
          used: false
        })
        newLeftToFind++
        newMatrix[randi][randj] = {
          ...newMatrix[randi][randj],
          value: letterPair[0],
          special: true
        }
      }
    } while (condition)          
    do {
      randi = Math.floor(Math.random() * state.GRIG_HEIGHT);
      randj = Math.floor(Math.random() * state.GRID_WIDTH);
      condition = letterPair.includes(newMatrix[randi][randj].value)   
      if (!condition) {
        newList.push({
          rowIndex: randi,
          columnIndex: randj,
          used: false
        })
        newLeftToFind++
        newMatrix[randi][randj] = {
          ...newMatrix[randi][randj],
          value: letterPair[1],
          special: true
        }
      }
    } while (condition)
    shuffle(newList)
    state.autoHelp.list = newList
    state.autoHelp.index = 0
  }
  return {
    gameMatrix: newMatrix,
    leftToFind: 18,
    lettersToFind: letterPair,
    gridSearchType: state.gridSearchType,
    autoHelp: state.autoHelp
  }
}

function cellClick(props) {
  let newMatrix = props.newMatrix
  newMatrix[props.rowIndex][props.columnIndex].isUsed = true
  newMatrix[props.rowIndex][props.columnIndex].animation = 'greenAnimation'
  return {
    newMatrix: newMatrix
  }
}

function mapStateToProps(state) {
  return {
    ...state[WORD_PAIRS_NAME]
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...letterJumbleContainerActions,
  dispatch
}, dispatch)

class LetterJumble extends React.Component {
  constructor(props) {
    props.setType({
      cellClick: cellClick,
      generateMatrix: generateMatrix
    },
    2.625, //points per click
    {
      remainingForAutoHelp: 2,
      list: [],
      index: 0
    })  // autohelp options
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
  }

  componentWillUnmount() {

  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ startOverlayTransitionIsFinished: true })}
        >
          <StartOverlay
            img={LetterJumbleImg}
            name={strings.LetterJumble_name}
            title={strings.LetterJumble_title}
            description={strings.LetterJumble_description}
            btnText={strings.OverlayView_btn_start}
            btnId={analyticsActions.LetterJumble.btnStart}
            onClick={() => { this.props.startPreExersize() }}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          <GameOver
            title={strings.LetterJumble_name}
            points={this.props.points}
            countDown={this.props.countDown}
            exersizeState={this.props.exersizeState}
            lettersMatrix={this.props.lettersMatrix}
            analyticsActions={analyticsActions.LetterJumble}
          />
        </CSSTransition>
        <CSSTransition
          in={
            (
              this.props.exersizeState === 'preexersize' ||
              this.props.exersizeState === 'gameStarted' ||
              this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ progressInfoTransitionIsFinished: true })}
        >

          <ProgressInfo
            timeLeft={this.props.timeLeft}
            points={this.props.points}
            name={strings.LetterJumble_name}
            title={strings.LetterJumble_title}
            game={
              <>
                <Timer
                  started={this.props.exersizeState === 'preexersize'}
                  increment={this.props.incrementCountDown}
                  interval={1000}
                  incrementCounter={this.props.countDown}
                  timerFinished={this.props.startGame}
                />
                <Timer
                  started={this.props.exersizeState === 'gameStarted'}
                  increment={this.props.increment}
                  interval={1000}
                  incrementCounter={this.props.timeLeft}
                  timerFinished={this.props.gameOverAction}
                />
                <CountDown key="countDown" countDown={this.props.countDown} />
                <Grid
                  exName="letter-search"
                  key="grid"
                  exersizeState={this.props.exersizeState}
                  onCellClick={this.props.cellClickAction}
                />
              </>
            }
          >
            <div className="col-md-6 col-sm-6 letter-jumble-to-find row">
              <div className="col-md-12 col-sm-12">
                {strings.SLMB_gesucht}{" "}
              </div>
              <span className="value col-md-12 col-sm-12">
                {this.props.lettersToFind.join(" · ")}
              </span>
            </div>
            <div className="col-md-6 col-sm-6 row">
              <div className="col-md-12 col-sm-12">
                {strings.SLMB_remaining}{" "}
              </div>
              <span className="value col-md-12 col-sm-12">
                {this.props.leftToFind}
              </span>
            </div>
          </ProgressInfo>
        </CSSTransition>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LetterJumble)
